import { Container } from "@mui/system"
import { Box, CssBaseline, FormControl, InputLabel, Select, MenuItem, Grid } from "@mui/material"
import DynamicDataGrid from '../components/DynamicDataGrid';
import { GridRowModes, GridActionsCellItem, GridRowEditStopReasons } from '@mui/x-data-grid';
import { useAuth } from "../context/AuthProvider"
import { useState, useEffect } from "react"
import dataService from '../services/Data'
import NavAppBar from "../components/NavAppBar"
import CustomDialog from "../components/CustomDialog"

export const TasasABM = () => {
    const { user } = useAuth()
    const [datosVehiculos, setDatosVehiculos] = useState(null)
    const [vehiculo, setVehiculo] = useState(0)
    const [datosCreditos, setDatosCreditos] = useState(null)
    const [credito, setCredito] = useState(0)
    const [datosModelos, setDatosModelos] = useState(null)
    const [modelo, setModelo] = useState(null)
    const [vehiculoSelec, setVehiculoSelec] = useState(0)
    const [creditoSelec, setCreditoSelec] = useState(0)
    const [rowsPlazo, setRowsPlazo] = useState([]);
    const error = "Debe vincular el vehiculo seleccionado a un Modelo y a un Tipo de Crédito para cargar las Tasas."
    const [msjError, setMostrarMsjError] = useState(false)
    const [tiposCredID, setTiposCredID] = useState(null)

    dataService.setToken(user.data.token)
    useEffect(() => {
        dataService.listarVehiculos(setDatosVehiculos, true)
        dataService.listarCreditos(setDatosCreditos, true)
        dataService.listarVehiculosTiposCredModelos(setDatosModelos)
        dataService.listarPlazos(setRowsPlazo);
    }, [])

    const [rows, setRows] = useState();
    const [rowModesModel, setRowModesModel] = useState({});

    const handleRowEditStop = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
    };

    const handleEditClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    const handleSaveClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    };

    const handleDeleteClick = (id) => () => {
        setRows(rows.filter((row) => row.id !== id));
    };

    const handleCancelClick = (id) => () => {
        setRowModesModel({
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });

        const editedRow = rows.find((row) => row.id === id);
        if (editedRow.isNew) {
            setRows(rows.filter((row) => row.id !== id));
        }
    };

    const processRowUpdate = (newRow) => {
        const updatedRow = { ...newRow, isNew: false };
        setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
    };

    const handleRowModesModelChange = (newRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };

    const columns = [{ field: 'tasaID', headerName: 'ID', width: 90, align: 'center', editable: false }, { field: 'plazo', headerName: 'PLAZO', width: 90, align: 'center', editable: false }, { field: 'cuota', headerName: 'CUOTA', width: 100, editable: true }];
    const columnsAdelCuota = [{ field: 'tasaID', headerName: 'ID', width: 60, align: 'center', editable: false }, { field: 'tasa', headerName: 'TASA', width: 80, align: 'right', editable: true }, { field: 'gasto', headerName: 'GASTO', width: 80, align: 'right', editable: true }, { field: 'gastoMensual', headerName: 'GASTO MENSUAL', width: 140, align: 'right', editable: true }];
    
    const handleCredito = (event) => {
        setCredito(event.target.value);
        setCreditoSelec(event.target.value);
    };

    const handleVehiculo = async (event) => {
        setVehiculo(event.target.value);
        setVehiculoSelec(datosVehiculos.find((item) => item.vehiculoID === event.target.value).vehiculoID);
        setCredito(null)
        setCreditoSelec(null)
        setModelo(null)
    }

    const handleModelo = (event) => {
        setModelo(event.target.value)
        setRows(null)
    };

    useEffect(() => {
        handleGet()
        setCredito(0)
        { datosModelos && setTiposCredID(datosModelos.filter(item => item.vehiculoID == vehiculoSelec).map(row => row.tipoCreditoID)) }
        //do operation on state change
    }, [vehiculo])

    useEffect(() => {
        handleGet()
        setModelo(0)
        //do operation on state change
    }, [credito])

    useEffect(() => {
        handleGet()
        //do operation on state change
    }, [modelo])

    // Handlers CRUD
    const handleGet = async () => {
        try {
            if (vehiculo == 0) {
                return;
            }
            //setMostrarMsjError(false);
            //console.log(credito, vehiculo, modelo);

            const adelCuota = datosVehiculos.find((item) => item.vehiculoID === vehiculo).adelantamientoCuota;
            if (!adelCuota && datosModelos.filter((veh) => veh.vehiculoID === vehiculo).length == 0) {
                setMostrarMsjError(true);
                return;
                //ESTO LO HICE POR QUE EL VEHICULO Camión EN TEORÍA NO TENÍA TIPO CREDITO NI MODELO VINCULADO
                //const response = dataService.listarTasasDataByParam(0, vehiculo, 0, setRows);
                //return response;
            }
            else {
                if (adelCuota) {
                    if (vehiculo === 0) {
                        setRows()
                        return;
                    }
                }
                else if (vehiculo === 0 || credito === null || credito === 0 || modelo === null || modelo === 0) {
                    //{

                    //}
                    //setTimeout(() => {
                    //    setMostrarMsjError(true)
                    //}, 300);
                    //console.log(msjError)
                    setRows()
                    return;
                }

                const response = dataService.listarTasasDataByParam(credito, vehiculo, modelo, setRows);
                return response;
            }
        } catch (err) {
            setError('Error al crear el registro');
            console.error(err);
            throw err;
        }
    };

    const handleCreate = async (newRow) => {
        try {
            //    const response = await dataService.insertarModelo(newRow)
            //    setRows([...rows, response]);
            //    return response;
        } catch (err) {
            setError('Error al crear el registro');
            console.error(err);
            throw err;
        }
    };

    const handleUpdate = async (updatedRow) => {
        try {
            if (updatedRow.tasaID === 0 && updatedRow.cuota === 0) {
                return;
            }

            const modifiedRow = {
                ...updatedRow,
                vehiculoID: vehiculo,
                tipoCreditoID: credito,
                modeloID: modelo// Ejemplo: agrega la fecha actual
            };

            const response = await dataService.insActTasa(modifiedRow)
            setRows(rows.map((row) => (row.id === updatedRow.id && row.plazoID === updatedRow.plazoID ? response : row)));
            return response;
        } catch (err) {
            setError('Error al actualizar el registro');
            console.error(err);
            throw err;
        }
    };

    const handleDelete = async (id) => {
        try {
            //    await api.delete(`/users/${id}`);
            //    setRows(rows.filter((row) => row.id !== id));
        } catch (err) {
            setError('Error al eliminar el registro');
            console.error(err);
            throw err;
        }
    };

    return (
        <>
            {!msjError ? "" : <CustomDialog message={error} btnText="OK" title="Aviso" state={setMostrarMsjError} open={msjError} />}
            <CssBaseline />
            <NavAppBar />
            <Container style={{ maxWidth: 450 }} >
                <Box display="flex" justifyContent="center" margin="dense">
                    <h2>Modificar Tasas</h2>
                </Box>
                <Box>
                    <FormControl fullWidth margin="dense">
                        <InputLabel id="2">Vehículo</InputLabel>
                        <Select fullWidth margin='dense' labelId="label" id="1" label="Vehículo" value={vehiculo} onChange={handleVehiculo}>
                            {datosVehiculos && datosVehiculos.map((dato) => (<MenuItem key={dato.vehiculoID} value={dato.vehiculoID}>{dato.nombre}</MenuItem>))}
                        </Select>
                    </FormControl>
                    { //vehiculoSelec == "Auto" && (
                        datosModelos && datosModelos.filter((veh) => veh.vehiculoID === vehiculoSelec).length > 0 ? (
                            <>
                                <FormControl fullWidth margin="dense">
                                    <InputLabel id="2">Tipo Crédito</InputLabel>
                                    <Select fullWidth margin='dense' labelId="label" id="2" label="Tipo Crédito" value={credito} onChange={handleCredito} >
                                        {datosCreditos && tiposCredID != null && datosCreditos.filter(item => tiposCredID.includes(item.tipoCreditoID)).map((dato) => (<MenuItem key={dato.tipoCreditoID} value={dato.tipoCreditoID}>{dato.nombre}</MenuItem>))}
                                    </Select>
                                </FormControl>
                                {credito !== 0 && (
                                    <FormControl fullWidth margin="dense">
                                        <InputLabel id="4">Modelo</InputLabel>
                                        <Select fullWidth margin="dense" labelId="label1" id="3" label="Modelo" value={modelo} onChange={handleModelo}>
                                            {datosModelos && datosModelos.filter((row) => row.vehiculoID == vehiculoSelec && row.tipoCreditoID == creditoSelec).map((dato) => (<MenuItem key={dato.modeloID} value={dato.modeloID}>{dato.modelo}</MenuItem>))}
                                        </Select>
                                    </FormControl>)}
                            </>
                        ) : ""
                    }
                </Box>
                <br />
                {rows && rows.length > 0 && !datosVehiculos.find((item) => item.vehiculoID === vehiculo).adelantamientoCuota ? (
                    <Grid className="contenedor" container spacing={0} maxWidth="500">
                        <DynamicDataGrid
                            showAddInfo={false}
                            hideFootInfo={true}
                            rows={rows}
                            columns={columns}
                            onCreate={handleCreate}
                            onUpdate={handleUpdate}
                            onDelete={handleDelete}
                        />
                    </Grid>
                ) : ""}
                {rows && rows.length > 0 && datosVehiculos.find((item) => item.vehiculoID === vehiculo).adelantamientoCuota ? (
                    <Grid className="contenedor" container spacing={0} maxWidth="500">
                        <DynamicDataGrid
                            showAddInfo={false}
                            hideFootInfo={true}
                            rows={rows}
                            columns={columnsAdelCuota}
                            onCreate={handleCreate}
                            onUpdate={handleUpdate}
                            onDelete={handleDelete}
                        />
                    </Grid>
                ) : ""}

            </Container>
        </>
    );
}